export const clinicsData = [
  {
    image: require("assets/images/contact-popup/image-1.jpg").default,
    name: "Poradnia w Wołominie",
    location: {
      street: "ul. Miła 3",
      city: "05-200 Wołomin",
      floor: "3",
    },
    contact: {
      phones: ["501 775 717", "721 642 466"],
      emails: ["recepcja@spokojwglowie.pl"],
    },
    hours: [
      "Poniedziałek - Piątek, od 8:00 do 21:00",
      "Sobota, od 8:00 do 19:00",
      "Niedziela, od 8:00 do 16:00",
    ],
  },
  {
    image: require("assets/images/contact-popup/image-2.jpg").default,
    name: "Poradnia Warszawa Białołęka",
    location: {
      street: "ul. Mochtyńska 65",
      city: "03-289 Warszawa",
    },
    contact: {
      phones: ["725 396 700"],
      emails: ["bialoleka@spokojwglowie.pl"],
    },
    hours: [
      "Poniedziałek - Piątek, od 9:00 do 21:00",
      "Sobota, od 8:00 do 16:00",
    ],
  },
];
